<template>
    <div class="preparation-customer-order-page">
        <transition name="loading-screen">
            <LoadingScreen v-if="loading" />
        </transition>
        <template v-if="errors">
            <ErrorsZone :errors="errors" />
        </template>
        <template v-if="loadedOnce && !errors && order">
            <div class="row mb-4 align-items-center">
                <div class="col-md-6 col-12">
                    <PreparationCustomerOrderCustomerInformation
                        :order="order"
                    />
                </div>
                <div class="col-md-6 col-12">
                    <OrderPreparationProgressBar
                        :label="order.status_label"
                        :preparation-status="progressCounters"
                    />

                    <div class="float-right mt-4">
                        <template v-if="orderDone">
                            <div v-if="order.final_customer_type === 'pickup_point_subcustomer'" class="dropdown d-inline-block">
                                <button class="btn lcdd-btn-with-icon btn-outline-primary btn-md ml-2"
                                        @click="$refs.modalOrderDistribution.showModal()"
                                        type="button" id="orderDistributedButton">
                                    <div class="lcdd-btn-icon">
                                        <i class="fad fa-shopping-cart fa-2x"></i>
                                    </div>
                                    Commande retirée<br />Envoyer la facture
                                </button>
                                <Modal ref="modalOrderDistribution" size="xlarge">
                                    <template #body="sp">
                                        <h2 class="mb-4">Confirmer le retrait de la commande</h2>
                                        <div class="alert alert-warning mb-4">
                                            Attention, cette action va envoyer une facture au client, assurez vous que la commande retirée est conforme à la facture.
                                        </div>
                                        <h4 class="mb-3">Rappel des produits de cette commande</h4>
                                        <table class="table table-striped table-bordered table-sm">
                                            <template v-for="categoryAndProducts in productsByMainCategory">
                                                <thead>
                                                    <tr>
                                                        <th>{{ categoryAndProducts.category.name }}</th>
                                                        <th style="width:10px">Commandé</th>
                                                        <th style="width:10px">Offert</th>
                                                        <th style="width:10px">Préparé</th>
                                                        <th style="width:10px">Manquant</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(entry, sku) in categoryAndProducts.products" :key="sku">
                                                        <td class="text-left">
                                                            {{ entry.product.tiny_name }}
                                                        </td>
                                                        <td class="text-center" style="width:10px">
                                                            {{ entry.preparation_status.preparation_counters.nb_ordered }}
                                                        </td>
                                                        <td class="text-center" style="width:10px">
                                                            {{ entry.preparation_status.preparation_counters.nb_offered }}
                                                        </td>
                                                        <td class="text-center" style="width:10px">
                                                            {{ entry.preparation_status.preparation_counters.nb_prepared }}
                                                        </td>
                                                        <td class="text-center" style="width:10px">
                                                            {{ entry.preparation_status.preparation_counters.nb_missing }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </table>
                                        <p>
                                            Attention, cette action va envoyer une facture au client, assurez vous que la commande retirée est conforme à la facture.
                                        </p>
                                        <div v-if="errorsSending" class="row mt-5 mb-3 align-items-center">
                                            <div class="col-md-12">
                                                <errors-zone :errors="errorsSending"></errors-zone>
                                            </div>
                                        </div>
                                        <div class="text-right">
                                            <button class="btn lcdd-btn-with-icon btn-primary btn-md ml-2" @click="confirmCollection">
                                                <div class="lcdd-btn-icon">
                                                    <i class="fad fa-shopping-cart fa-2x"></i>
                                                </div>
                                                Le client a récupéré sa commande<br />
                                                Envoyer la facture !
                                            </button>
                                        </div>
                                    </template>
                                    <template #footer>
                                        <button class="btn btn-secondary" @click="$refs.modalOrderDistribution.closeModal()">
                                            Fermer
                                        </button>
                                    </template>
                                </Modal>
                            </div>
                            <div v-if="order.final_customer_type === 'short_channel' || order.final_customer_type === 'customer_group'" class="dropdown d-inline-block">
                                <button class="btn lcdd-btn-with-icon btn-outline-primary btn-md ml-2"
                                        @click="confirmCollectionShortCircuitOrCustomerGroup"
                                        type="button" id="orderDistributedButton">
                                    <div class="lcdd-btn-icon">
                                        <i class="fad fa-shopping-cart fa-2x"></i>
                                    </div>
                                    <template v-if="order.final_customer_type === 'short_channel'">
                                        Circuit court livré !<br/>Marquer distribuée
                                    </template>
                                    <template v-if="order.final_customer_type === 'customer_group'">
                                        Groupement de clients livré !<br/>Marquer distribuée
                                    </template>
                                </button>
                            </div>
                        </template>
                        <button @click="$refs.modalCustomerInformation.showModal()" class="btn lcdd-btn-with-icon btn-outline-dark mx-2">
                            <div class="lcdd-btn-icon">
                                <i class="fad fa-file-user fa-2x"></i>
                            </div>
                            Infos<br />commande
                        </button>
                        <button v-if="order.final_customer_type === 'short_channel' || order.final_customer_type === 'customer_group'" @click="displaySubcustomers = !displaySubcustomers" class="btn lcdd-btn-with-icon btn-outline-dark mx-2">
                            <div class="lcdd-btn-icon">
                                <i class="fad fa-eye fa-2x"></i>
                            </div>
                            <template v-if="displaySubcustomers">
                                Cacher<br>les clients
                            </template>
                            <template v-else>
                                Voir<br>les clients
                            </template>
                        </button>
                        <a :href="`/espace-employes/commandes/preparation/commande/${order.id}/bon-livraison/menu`" class="btn lcdd-btn-with-icon btn-outline-dark mx-2">
                            <div class="lcdd-btn-icon">
                                <i class="fad fa-print fa-2x"></i>
                            </div>
                            Imprimer<br />le BL
                        </a>
                        <OrderPreparationMenu
                            :order="order"
                            :cancellation-reasons="cancellationReasons"
                            :products-by-main-category="productsByMainCategory"
                        />

                        <CustomerInformationModal
                            ref="modalCustomerInformation"
                            :order="order"
                        />
                    </div>
                </div>
            </div>

            <PreparationOrderDelivery
                :order="order"
                :containers-types="containersTypes"
                :products-by-main-category="productsByMainCategory"
            />

            <div v-if="errorsSending" class="row mb-3 align-items-center">
                <div class="col-md-12">
                    <errors-zone :errors="errorsSending"></errors-zone>
                </div>
            </div>

            <Comments
                :commentable-type="'App\\Models\\Order'"
                :commentable-id="order.id"
                :comments="order.comments"
            ></Comments>

            <div v-if="!order.ready_to_prepare" class="alert alert-info mb-4 h4">
                <i class="fad fa-info-circle"></i> Cette commande n'est pas encore terminée. Vous ne pouvez pas préparer la commande pour le moment.
            </div>

            <template v-if="subcustomersPickupPoints && subcustomersPickupPoints.length > 1">
                <div class="row mb-2">
                    <div class="col-12">
                        <div class="form-group">
                            <label class="form-label font-weight-bold" for="pickupPointFilter">Filtrer par lieu de retrait</label>
                            <select
                                class="form-control"
                                id="pickupPointFilter"
                                v-model="filterSubcustomerPickupPoint"
                            >
                                <option :value="null">
                                    Tous les lieux de retrait
                                </option>
                                <option
                                    v-for="pickupPoint in subcustomersPickupPoints"
                                    :key="pickupPoint"
                                    :value="pickupPoint"
                                >
                                    {{ pickupPoint }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </template>

            <div v-if="!productsByMainCategory.length" class="alert alert-info mb-4 h4">
                Aucun produit n'a été commandé pour le moment.
            </div>

            <template v-for="categoryAndProducts in productsByMainCategory">
                <div class="row mt-4">
                    <div class="col-md-12">
                        <h3>{{ categoryAndProducts.category.name }}</h3>
                    </div>
                </div>

                <div class="row">
                    <PreparationProduct
                        v-for="(entry, sku) in categoryAndProducts.products"
                        class="col-md-4 mb-3"
                        :key="sku"
                        :order="order"
                        :product="entry.product"
                        :preparation-status="entry.preparation_status"
                        :inputs="entry.inputs"
                        :cancellation-reasons="cancellationReasons"
                        :display-subcustomers="displaySubcustomers"
                        :subcustomers-orders="subcustomersOrdersDisplayedBySku[sku] || []"
                        :display-pickup-points-names="displayPickupPointsNames"
                        :read-only="!order.ready_to_prepare"
                    >
                        {{ entry.product.tiny_name }}
                    </PreparationProduct>
                </div>
            </template>

        </template>
    </div>
</template>

<script>
import PreparationProduct from "./PreparationProduct";
import OrderPreparationMenu from "./OrderPreparationMenu";
import OrderPreparationProgressBar from "./CustomerOrder/OrderPreparationProgressBar";
import CustomerInformationModal from "./CustomerOrder/CustomerInformationModal";
import PreparationOrderDelivery from "./PreparationOrderDelivery"
import PreparationCustomerOrderCustomerInformation from "./PreparationCustomerOrderCustomerInformation"
import ErrorsZone from "../ErrorsZone";
import InputIntegerPositive from "../InputIntegerPositive"
import LoadingScreen from "../LoadingScreen";

import Comments from "../Comments"
import {useGetLoader} from "../compositions/axios/loadingRequest";

import {usePostRequest} from "../compositions/axios/postRequest";
import {orderDone, orderReady} from "../../orders-utils";

export default {
    name: 'PreparationCustomerOrderPage',

    components: {
        InputIntegerPositive,
        ErrorsZone,
        LoadingScreen,
        PreparationProduct,
        OrderPreparationMenu,
        OrderPreparationProgressBar,
        PreparationOrderDelivery,
        PreparationCustomerOrderCustomerInformation,
        CustomerInformationModal,
        Comments,
    },

    props: {
        orderId: {
            type: String,
            required: true,
        },
    },

    setup() {
        const {
            loaded,
            loading,
            errors,
            load,
        } = useGetLoader();

        const {
            loaded: sent,
            loading: sending,
            errors: errorsSending,
            post,
        } = usePostRequest();

        return {
            loaded,
            loading,
            errors,
            load,

            sent,
            sending,
            errorsSending,
            post,
        };
    },

    data() {
        return {
            order: null,
            productsByMainCategory: [],
            progressCounters: {
                nb_ordered: 0,
                nb_prepared: 0,
                nb_missing: 0,
                color: '',
            },
            cancellationReasons: [],
            containersTypes: [],
            loadedOnce: false,
            displaySubcustomers: false,
            filterSubcustomerPickupPoint: null,
        };
    },

    created() {
        Echo.private(`employees`)
            .listen('OrderUpdatedEvent', (e) => {
                if (e.order.id == this.orderId) {
                    this.loadStateFromServer();
                }
            });
    },

    async mounted() {
        this.loadStateFromServer();
    },

    methods: {
        async loadStateFromServer() {
            const data = await this.load(`/espace-employes/commandes/preparation/commande/${this.orderId}/json`);
            if (data) {
                this.order = data.order;
                if (this.order.final_customer_type === 'short_channel' || this.order.final_customer_type === 'customer_group') {
                    this.displaySubcustomers = true;
                }
                this.productsByMainCategory = data.productsByMainCategory;
                this.progressCounters = data.progressCounters;
                this.cancellationReasons = data.cancellationReasons;
                this.containersTypes = data.containersTypes;

                this.loadedOnce = true;
            }
        },

        async confirmCollection() {
            if(confirm('Attention, cette action va envoyer une facture au client, assurez vous que la commande retirée est conforme à la facture')) {
                const response = await this.post(`/espace-employes/commandes/preparation/commande/${this.orderId}/confirmer-distribution`);

                if (!this.errorsSending) {
                    if (!this.$root.echoConnectedWihoutErrors) {
                        window.location.reload();
                    }
                }
            }
        },

        async confirmCollectionShortCircuitOrCustomerGroup() {
            if(confirm('Confirmez-vous que le client a été livré et que la distribution est terminée ?')) {
                const response = await this.post(`/espace-employes/commandes/preparation/commande/${this.orderId}/confirmer-distribution`);

                if (!this.errorsSending) {
                    if (!this.$root.echoConnectedWihoutErrors) {
                        window.location.reload();
                    }
                }
            }
        },
    },

    computed: {
        subcustomersOrdersDisplayedBySku() {
            const subcustomersBySku = {};
            for (const orderedProduct of this.order.ordered_products) {
                if (!subcustomersBySku.hasOwnProperty(orderedProduct.sku)) {
                    subcustomersBySku[orderedProduct.sku] = [];
                }
                const subcustomer = this.order.subcustomers.find((c) => c.id == orderedProduct.pivot.fk_subcustomer);
                if (subcustomer && this.filterSubcustomerPickupPoint === null || subcustomer?.meta?.pickup_point === this.filterSubcustomerPickupPoint) {
                    subcustomersBySku[orderedProduct.sku].push({
                        subcustomer: subcustomer,
                        quantity: orderedProduct.pivot.quantity,
                        ref: orderedProduct.pivot.ref,
                    });
                }
            }
            return subcustomersBySku;
        },

        subcustomersPickupPointsDisplayed() {
            if (this.filterSubcustomerPickupPoint) {
                return [this.filterSubcustomerPickupPoint];
            }
            return this.subcustomersPickupPoints;
        },

        subcustomersPickupPoints() {
            const pickupPoints = [];
            if (this.order.subcustomers) {
                for (const subcustomer of this.order.subcustomers) {
                    const pickupPoint = subcustomer?.meta?.pickup_point || null;
                    if (pickupPoint && pickupPoints.indexOf(pickupPoint) === -1) {
                        pickupPoints.push(pickupPoint);
                    }
                }
            }
            return pickupPoints;
        },

        displayPickupPointsNames() {
            if (this.subcustomersPickupPoints) {
                return this.subcustomersPickupPoints.length > 1;
            }
            return false;
        },

        orderDone,
    },
}
</script>
